import { FC } from "react";

const PrivacyPageIubenda: FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <iframe
        src="https://www.iubenda.com/privacy-policy/81463212/legal"
        title="Privacy Policy"
        className="w-full h-screen border-0"
      />
    </div>
  );
}

export default PrivacyPageIubenda;
